import dynamic from "next/dynamic";
import { useRouter } from "next/router";

const LandingNavbar = dynamic(() => import("@components/landing/LandingNav"), {
  ssr: true,
});
const Footer = dynamic(() => import("@components/landing/Footer"), {
  ssr: true,
});
const ScrollTop = dynamic(() => import("@components/landing/ScrollTop"), {
  ssr: false,
});

const BaseLayout = ({ children }) => {
  const { pathname, query } = useRouter();
  const isAppQuery = query.app === "true";
  const showNavFooter = !isAppQuery && !pathname.startsWith("/viewer");
  const isWhite = !(pathname === "/" || pathname === "" || pathname === "/faq");
  const showFooter = !pathname.includes("/investment-calculator");

  return (
    <div className="flex min-h-screen w-full">
      <div className="flex justify-center w-full">
        <div className="flex flex-col w-full overflow-x-clip text-black">
          {showNavFooter && <LandingNavbar isWhite={isWhite} />}
          {children}
          {showNavFooter && showFooter && (
            <>
              <Footer />
              <ScrollTop />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default BaseLayout;
